import { render, staticRenderFns } from "./studentStar.vue?vue&type=template&id=a0e8b9f4&scoped=true&"
import script from "./studentStar.vue?vue&type=script&lang=js&"
export * from "./studentStar.vue?vue&type=script&lang=js&"
import style0 from "./studentStar.vue?vue&type=style&index=0&id=a0e8b9f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e8b9f4",
  null
  
)

export default component.exports